import React from "react";
import TextButton from "../../../templates/component/buttons/textButton";

const WorkAddButton = () =>{

    return(
        <>
            <TextButton />

        </>
    )
}

export default WorkAddButton;